// extracted by mini-css-extract-plugin
export var header = "Header-module--header--kDEtM";
export var hamburger = "Header-module--hamburger--HOUmj";
export var span = "Header-module--span--wcb86";
export var button = "Header-module--button--M6UvQ";